var React = require('react');

function KibanaInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 306.93v34.012h15.986L156.32 172.718a265.907 265.907 0 0 0-30.34-17.006L0 306.929z","fill":"#009B90","key":0}),React.createElement("path",{"d":"M156.324 172.718L15.922 341.01h239.65c0-68.569-38.91-129.519-99.248-168.292z","fill":"#40BEB0","key":1}),React.createElement("path",{"fill":"#EF5098","d":"M0 0v307.445L256 0z","key":2}),React.createElement("path",{"d":"M.068 307.34l126.175-151.495C86.693 137.372 43.651 127.805 0 128.003L.068 307.34z","fill":"#353535","key":3})]);
}

KibanaInline.defaultProps = {"viewBox":"0 0 256 342","preserveAspectRatio":"xMidYMid"};

module.exports = KibanaInline;

KibanaInline.default = KibanaInline;
